module.exports = __webpack_public_path__ + "static/media/close.777b93c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/close.svg
// module id = 97
// module chunks = 0